module.exports = __webpack_public_path__ + "static/media/multipleuser.2424430b.svg";